export var BackupZeroEtlPolicyScope;
(function (BackupZeroEtlPolicyScope) {
    BackupZeroEtlPolicyScope["BACKUP_ZERO_ETL_POLICY_SCOPE_MULTI_RESOURCE"] = "BACKUP_ZERO_ETL_POLICY_SCOPE_MULTI_RESOURCE";
    BackupZeroEtlPolicyScope["BACKUP_ZERO_ETL_POLICY_SCOPE_SINGLE_RESOURCE"] = "BACKUP_ZERO_ETL_POLICY_SCOPE_SINGLE_RESOURCE";
})(BackupZeroEtlPolicyScope || (BackupZeroEtlPolicyScope = {}));
